module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey"
    }
  }, [(_vm.globalModalParams.type != 'orig_region' && _vm.globalModalParams.type != 'customer_region') ? _c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Details")]) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.type != 'customer' && _vm.globalModalParams.type != 'orig_region' && _vm.globalModalParams.type != 'customer_region') ? _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Limits")]) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.type != 'customer' && _vm.globalModalParams.type != 'orig_region' && _vm.globalModalParams.type != 'customer_region') ? _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Pricelists")]) : _vm._e(), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Regions")]), _vm._v(" "), (_vm.globalModalParams.type != 'orig_region' && _vm.globalModalParams.type != 'customer_region') ? _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Full Name:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.name) + " " + _vm._s(_vm.objUserInfo.surname))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Role:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.role))]), _vm._v(" "), (_vm.objUserInfo.contactno == '') ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Contact No:")]), _c('br'), _vm._v("N/A")]) : _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Contact No:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.contactno))]), _vm._v(" "), (_vm.objUserInfo.alt_contactno == '') ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Alternative No:")]), _c('br'), _vm._v("N/A")]) : _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Alternative No:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.alt_contactno))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Email Address:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.email))]), _vm._v(" "), (_vm.objUserInfo.vat_no == '') ? _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("VAT No:")]), _c('br'), _vm._v("N/A")]) : _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("VAT No:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.vat_no))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Physical Address:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.address))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Preferred Follow Up:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.pmoc))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Active for MyOrder:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.active))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("User Type:")]), _c('br'), _vm._v(_vm._s(_vm.fncReturnUserType(_vm.objUserInfo.type)))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Created On:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.created))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Last modified:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.modified))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.type != 'customer' && _vm.globalModalParams.type != 'orig_region' && _vm.globalModalParams.type != 'customer_region') ? _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Maximum Discounts:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.discount_max) + "%")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Default Discounts:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.discount_def) + "%")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('strong', [_vm._v("Maximum Incidental Value:")]), _c('br'), _vm._v(_vm._s(_vm.objUserInfo.inc_max) + "%")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.type != 'customer' && _vm.globalModalParams.type != 'orig_region' && _vm.globalModalParams.type != 'customer_region') ? _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 minTable",
    attrs: {
      "headers": _vm.plistHeaders,
      "items": _vm.objUserInfo.pricelist_names,
      "expand": "",
      "hide-actions": "",
      "rows-per-page-items": [10000000]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100%"
          }
        }, [_vm._v(_vm._s(props.item)), (props.item.children && props.item.children.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_upward")]) : _vm._e()])])]
      }
    }], null, false, 1068786494)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('div', {
    staticClass: "popupTable",
    staticStyle: {
      "width": "100%",
      "overflow-y": "auto"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 mainTable",
    attrs: {
      "headers": _vm.regionHeaders,
      "items": _vm.objUserInfo.allRegions,
      "expand": "",
      "hide-actions": "",
      "rows-per-page-items": [10, 20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [(props.expanded == true) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "100%"
          },
          on: {
            "click": function($event) {
              props.expanded = !props.expanded
            }
          }
        }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
          staticClass: "material-icons showHide"
        }, [_vm._v("arrow_downward")]) : _vm._e()])])]
      }
    }, {
      key: "expand",
      fn: function(props) {
        return [_c('v-data-table', {
          staticClass: "elevation-1 subTable subTable1 minTable",
          attrs: {
            "search": _vm.search,
            "headers": _vm.regionHeaders,
            "items": props.item.children,
            "expand": "",
            "hide-actions": "",
            "rows-per-page-items": [10000000]
          },
          scopedSlots: _vm._u([{
            key: "items",
            fn: function(props) {
              return [_c('tr', [(props.expanded == true) ? _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "100%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                staticClass: "text-xs-right",
                attrs: {
                  "width": "100%"
                },
                on: {
                  "click": function($event) {
                    props.expanded = !props.expanded
                  }
                }
              }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
                staticClass: "material-icons showHide"
              }, [_vm._v("arrow_downward")]) : _vm._e()])])]
            }
          }, {
            key: "expand",
            fn: function(props) {
              return [_c('v-data-table', {
                staticClass: "elevation-1 subTable2 minTable",
                attrs: {
                  "search": _vm.search,
                  "headers": _vm.regionHeaders,
                  "items": props.item.children,
                  "expand": "",
                  "hide-actions": "",
                  "rows-per-page-items": [10000000]
                },
                scopedSlots: _vm._u([{
                  key: "items",
                  fn: function(props) {
                    return [_c('tr', [(props.expanded == true) ? _c('td', {
                      staticClass: "text-xs-right",
                      attrs: {
                        "width": "100%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                      staticClass: "text-xs-right",
                      attrs: {
                        "width": "100%"
                      },
                      on: {
                        "click": function($event) {
                          props.expanded = !props.expanded
                        }
                      }
                    }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
                      staticClass: "material-icons showHide"
                    }, [_vm._v("arrow_downward")]) : _vm._e()])])]
                  }
                }, {
                  key: "expand",
                  fn: function(props) {
                    return [_c('v-data-table', {
                      staticClass: "elevation-1 subTable3 minTable",
                      attrs: {
                        "search": _vm.search,
                        "headers": _vm.regionHeaders,
                        "items": props.item.children,
                        "expand": "",
                        "hide-actions": "",
                        "rows-per-page-items": [10000000]
                      },
                      scopedSlots: _vm._u([{
                        key: "items",
                        fn: function(props) {
                          return [_c('tr', [(props.expanded == true) ? _c('td', {
                            staticClass: "text-xs-right",
                            attrs: {
                              "width": "100%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_upward")]) : _vm._e()]) : _c('td', {
                            staticClass: "text-xs-right",
                            attrs: {
                              "width": "100%"
                            },
                            on: {
                              "click": function($event) {
                                props.expanded = !props.expanded
                              }
                            }
                          }, [_vm._v(_vm._s(props.item.NAME) + " "), (props.item.children && props.item.children.length > 0) ? _c('i', {
                            staticClass: "material-icons showHide"
                          }, [_vm._v("arrow_downward")]) : _vm._e()])])]
                        }
                      }], null, true)
                    })]
                  }
                }], null, true)
              })]
            }
          }], null, true)
        })]
      }
    }])
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v(" ")])])])], 1)], 1)
},staticRenderFns: []}